import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/dice-roll-probability',
  component: () => import('../../routes/DiceRollProbability.svelte'),
  card: {
    id: 'dice-roll-probability',
    title: 'Dice Roll Probability',
    description: 'Calculate the probability of rolling a specific sum with any number of dice, with full probability distribution.',
    icon: 'casino',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/dice-roll-probability',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Dice Roll Probability Calculator – Roll any Number of Dice',
    description: 'Free dice roll probability calculator. Calculate the chance of rolling any sum with 1 to 10 dice. See the full probability distribution, expected value, and odds for each possible outcome.',
  },
};

export default meta;